import React from 'react';
import { ReactEditor, useFocused } from 'slate-react';
import { Range } from 'slate';

export default function useLastFocusedEditorSelection(
  editor: ReactEditor,
): Range {
  const isEditorFocused = useFocused();
  const editorSelection = React.useRef<any>(editor.selection);

  React.useEffect(() => {
    if (isEditorFocused) {
      editorSelection.current = editor.selection;
    }
  }, [editor.selection, isEditorFocused]);

  return editorSelection.current;
}
